<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div :class="bodyClassName">
      <div class="row">
				<div class="col-md-12">
          <h3 v-if="route.id">{{ route.name }}</h3>
          <h3 v-else>{{ _('New route') }}</h3>
        </div>
      </div>
      <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getComponentLock(true, 'TransportationRouteDetails')" />
      <editor-tabs id="tabNavi" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <div v-bind="tabPanel('route')" class="tab-pane active" id="route" v-if="isTabActive('route')" key="route">
          <div class="row">
            <div id="productsorter" class="col-sm-6 leftcol">
              <div class="form-group languageversioned">
                <label for="name">{{ _('Name') }}</label>
                <input type="text" class="form-control" id="routeName" v-model="route.name" :placeholder="_('Enter route name')">
              </div>
              <hr />
              <div class="panel panel-default">
                <div class="panel-heading">{{ _('Route stops') }}</div>
                <draggable v-model="route.sharedStop" tag="ul" draggable=".list-group-item" :delay="100" :delayOnTouchOnly="true" :componentData="{ attrs: { class: 'o-sortable-ticket sortable-list sorted-ticket list-group' }}">
                  <li v-for="stop in route.sharedStop" class="list-group-item" v-on:click="editStopDialog(stop)">{{ stop.name }} <span class="pull-right" v-if="parseInt(stop.offset)">{{ stop.offset }} {{ _('min') }}</span></li>
                </draggable>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <select id="select-ticket" class="form-control" :placeholder="_('Select a stop or enter new stop name...')" v-model="stopToAdd">
                    <option v-for="stop in selectableStops" :value="stop.id">{{ stop.name }}</option>
                  </select>
                  <span class="input-group-btn">
                    <button id="add-ticket" type="button" class="btn btn-success" v-on:click="addStop">{{ _('Add') }}</button>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-sm-6 rightcol">
              <label></label>
              <p>{{ _('Routes consist of two or more stops. Add stops to the route with the drop down selector below the list.') }}</p>
              <p>{{ _('If the stop does not exist in the system, you can create a new stop by clicking the Add button when no stop is selected.') }}</p>
              <p>{{ _('By clicking the stop name you can modify its name, zones and time offset relative to the route start.') }}</p>
            </div>
          </div>
        </div>
        <div v-bind="tabPanel('zones')" class="tab-pane active" id="zones" v-if="isTabActive('zones')" key="zones">
          <div class="row">
            <div class="col-xs-12">
              <h3>{{ _('Zones') }}</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <div class="panel panel-default">
                <div class="panel-heading">{{ _('Zones') }}</div>
                <ul class="list-group" id="allZonesList">
                  <li class="list-group-item" v-for="zone in allZones" v-on:click="editZoneDialog(zone)">{{ zone.name }}</li>
                </ul>
              </div>
              <button id="add-zone" type="button" class="btn btn-success" v-on:click="addZoneDialog()">{{ _('Add') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <nav class="save-bar flex-row">
      <div class="flex-row align-right">
        <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
        <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import changewatcher from '~/lib/changewatcher'
import components from '~/lib/components'
import { DateTime } from 'luxon'

export default {
  data () {
    return {
      allStops: [],
      allZones: [],
      allRoutes: [],
      activeTab: 'route',
      route: {},
      stopToAdd: null,
      zoneToAdd: null
    }
  },
  mixins: [changewatcher, components],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'route', label: this._('Route') },
        { id: 'zones', label: this._('Zones') }
      ])
    },
    selectableStops () {
      const stops = this.route && this.route.sharedStop ? this.route.sharedStop.map(p => p.id) : []
      // Offer one stop per name. Earlier saves could create several stops with the same name, so prefer
      // the one used on the most routes (then the oldest) to keep e.g. outbound and return routes on the same stop.
      const byName = new Map()
      this.allStops.forEach(s => {
        const current = byName.get(s.name)
        const routes = s.routes || 0
        const currentRoutes = current ? current.routes || 0 : 0
        if (!current || routes > currentRoutes || (routes === currentRoutes && parseInt(s.id, 10) < parseInt(current.id, 10))) {
          byName.set(s.name, s)
        }
      })
      return [...byName.values()].filter(s => !stops.includes(s.id))
    },
    selectableZones () {
      return []
      /*
      const zones = this.pricing && this.pricing.ownPricing_zone ? this.pricing.ownPricing_zone.map(p => p.zone_id) : []
      return this.allZones.filter(z => !zones.includes(z.id))
      */
    }
  },
  methods: {
    editStopDialog (stop) {
      this.showDialog({
        title: this._('Stop'),
        width: 800,
        buttons: [
          {
            title: this._('Delete'),
            class: 'danger',
            icon: 'trash',
            handler: () => {
              this.removeStop(stop)
            }
          },
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('OK'),
            class: 'success',
            icon: 'check',
            requiredFields: ['name'],
            handler: (data) => {
              this.saveStop(stop, data)
            }
          }
        ],
        fields: [
          {
            type: 'h3',
            text: this._('General')
          },
          {
            title: this._('Name'),
            type: 'text',
            name: 'name',
            placeholder: this._('Enter stop name'),
            defaultValue: stop.name,
            localized: true
          },
          {
            title: this._('Zones'),
            type: 'multiselect',
            name: 'zones',
            placeholder: this._('Select zones'),
            options: this.allZones.map(z => { return { value: z.id, name: z.name }}),
            defaultValue: stop.sharedZone ? stop.sharedZone.map(z => z.id) : []
          },
          {
            type: 'info',
            text: this._('A stop may have one or more associated zones. Zones are used in pricing.')
          },
          {
            type: 'location',
            name: 'coordinates',
            defaultValue: {
              lat: stop.lat,
              lng: stop.lng
            }
          },
          {
            type: 'separator'
          },
          {
            type: 'h3',
            text: this._('Route details')
          },
          {
            title: this._('Time offset from the start of route'),
            type: 'text',
            name: 'offset',
            placeholder: this._('minutes'),
            defaultValue: stop.offset,
            addon: this._('min')
          }
        ]
      })
    },
    saveStop (stop, data) {
      ['name', 'offset'].forEach(v => {
        if (data.hasOwnProperty(v)) {
          stop[v] = data[v]
        }
      })
      if (data.coordinates) {
        stop.lat = data.coordinates.lat
        stop.lng = data.coordinates.lng
      }
      stop.sharedZone = this.allZones.filter(z => data.zones && data.zones.length && data.zones.includes(z.id))
      if (stop.id.match && stop.id.match(/^new-/) && !this.route.sharedStop.find(s => s.id === stop.id)) {
        this.route.sharedStop.push(stop)
      }
    },
    removeStop (stop) {
      this.route.sharedStop = this.route.sharedStop.filter(p => p.id !== stop.id)
    },
    addStop () {
      if (this.stopToAdd) {
        this.route.sharedStop.push(this.allStops.find(t => t.id === this.stopToAdd))
        this.editStopDialog(this.route.sharedStop[this.route.sharedStop.length - 1])
      } else {
        this.editStopDialog({ id: 'new-' + DateTime.now().toMillis() })
      }
      this.stopToAdd = null
    },
    editZoneDialog (zone) {
      const buttons = [
        {
          title: this._('Close'),
          icon: 'close',
          handler: () => {}
        },
        {
          title: this._('OK'),
          class: 'success',
          icon: 'check',
          requiredFields: ['name'],
          handler: (data) => {
            if (zone) {
              this.saveZone(zone, data)
            } else {
              this.saveZone(null, data)
            }
          }
        }
      ]
      if (zone) {
        buttons.unshift({
          title: this._('Delete'),
          class: 'danger',
          icon: 'trash',
          handler: () => {
            this.removeZone(zone)
          }
        })
      }
      this.showDialog({
        title: this._('Zone'),
        width: 800,
        buttons: buttons,
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name',
            defaultValue: zone ? zone.name : '',
            localized: true
          }
        ]
      })
    },
    addZoneDialog () {
      this.editZoneDialog(null)
    },
    saveZone (zone, data) {
      if(zone) {
        for (let i = 0; i < this.allZones.length; i++) {
          if(this.allZones[i].id == zone.id) {
            this.allZones[i].name = data.name
          }
        }
      } else {
        let newData = {}
        newData.name = data.name
        newData.id = 'new-' + (new Date().getTime())
        this.allZones.push(newData)
      }
    },
    removeZone (data) {
      if (data && data.id) {
        this.allZones = this.allZones.filter(z => z.id != data.id)
      }
    },
    async loadAllStops () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/stops.json?zones=true&routes=true&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(e)
        return
      }
      this.allStops = response.data
    },
    async loadAllZones () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/zones.json?apikey=' + this.apiKey)
      } catch(e) {
        this.showError(e)
        return
      }
      this.allZones = response.data
    },
    getSaveData () {
      const exportFields = [
        'id',
        'name'
      ]
      const data = exportFields.reduce((a, e) => (a[e] = this.route[e], a), {})
      data.stops = JSON.stringify(this.route.sharedStop)
      data.zones = JSON.stringify(this.allZones)
      /*
      data.tickets = JSON.stringify(this.pricing.sharedProduct)
      data.zones = JSON.stringify(this.pricing.ownPricing_zone)
      */
      return data
    },
    async save () {
      this.saving = true
      const data = this.getSaveData()
      let response
      try {
        if (data.id) {
          response = await axios.put(this.baseDomain + this.shopId + '/routes/' + data.id + '.json?apikey=' + this.apiKey, data)
        } else {
          delete data.id
          response = await axios.post(this.baseDomain + this.shopId + '/routes.json?apikey=' + this.apiKey, data)
        }
      } catch(e) {
        this.saving = false
        return this.showError(e)
      }
      // Reload after every save so that new stops and zones get their stored ids. Otherwise the
      // next save would send the temporary new- ids again and the backend would create them again.
      const routeId = data.id || (response && response.data && (response.data.id || response.data))
      if (routeId) {
        await Promise.all([this.loadRoute(routeId), this.loadAllStops(), this.loadAllZones()])
      }
      this.saving = false
      this.saved = true
      this.storeState()
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      this.$emit('save', this.resource)
      if (this.saveShouldClose) {
        this.close()
      }
    },
    loadRoute (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/routes/' + id + '.json?stops=true&apikey=' + this.apiKey)
        } catch (e) {
          this.showError(e)
          reject()
          this.loading = false
          return
        }
        this.route = response.data
        this.storeState()
        this.loading = false
        resolve(this.route)
      })
    }
  },
  created () {
    if (this.component && this.component.initData) {
      this.loadRoute(this.component.initData.routeId)
    }
    this.loadAllStops()
    this.loadAllZones()
  },
  async updated () {
    if (this.component && this.component.initData) {
      if (this.route && this.route.id && parseInt(this.route.id, 10) !== parseInt(this.component.initData.routeId, 10)) {
        try {
          await this.loadRoute(this.component.initData.routeId)
        } catch(e) {}
      }
    }
  },
  async mounted () {
    if(!this.events) {
      let events = {}
      events['routeUpdate'] = async (message) => {
        if (message && message.data && this.route && parseInt(message.data.id, 10) === parseInt(this.route.id, 10)) {
          if (!this.unsavedChanges) { // Only update if we haven't made any changes
            this.loadRoute(message.data.id)
          }
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>
